export default "__VITE_ASSET__DvAWMbaC__"